export const pages = [
  { id: 1, title: "Teams", link: "teams" },
  { id: 2, title: "Venues", link: "venues" },
  { id: 4, title: "Advertisements", link: "ads" },
  { id: 5, title: "Qualifying scores", link: "qualifying-scores" },
  { id: 6, title: "Governing bodies", link: "governing-bodies" },
  { id: 7, title: "Message templates", link: "message-templates" },
  { id: 8, title: "Tools", link: "tools" },
  { id: 9, title: "Rules", link: "rules" },
];

export const AD_FIELDS_TITLE = {
  id: "ID",
  imageUrl: "Image",
  name: "Name",
  status: "Status",

  adType: "Type",
  ages: "Ages",
  levels: "Levels",
  priority: "Priority",

  targetRoles: "Roles",
  maxUniqueClicks: "Target Clicks",
  maxUniqueImpressions: "Target Impressions",

  startDate: "Start",
  endDate: "End",
  creationDate: "Created",
};

export const VENUE_FIELDS_TITLE = {
  id: "ID",
  poolName: "Pool name",
  schoolInstitution: "School/Institution",
  aquaticCenter: "Aquatic center",
  building: "Building",
  country: "Country",
  county: "County",
  state: "State",
  city: "City",
  streetOne: "Street 1",
  streetTwo: "Street 2",
  streetThree: "Street 3",
  postalCode: "Postal code",
  timezone: "Timezone",
  email: "Email",
  backupEmail: "Backup email",
  googleMapsLink: "Google map link",
  mobilePhone: "Mobile phone",
  website: "Website",
};

export const REQUIRED_FIELDS = [
  "abbreviation",
  "country",
  "state",
  "city",
  "timezone",
];

export const TEAM_TYPE_OPTIONS = [
  { value: "H", label: "H - High school" },
  { value: "U", label: "U - College/University" },
  { value: "C", label: "C - Club" },
  { value: "F", label: "F - Facility" },
  { value: "S", label: "S - Summer league" },
  { value: "G", label: "G - Governing body" },
];

export const TEAM_TYPE_VALUES = TEAM_TYPE_OPTIONS.map((item) => item.value);
export const GOVERNING_BODY_TEAM_TYPE_VALUES = TEAM_TYPE_VALUES.filter(
  (value) => value !== "G",
);

export const GOVERNING_BODY_FIELDS_TITLE = {
  id: "ID",
  abbreviation: "Abbreviation",
  imageUrl: "Logo",
  name: "Name",
  shortName: "Short name",
  outputSequence: "Output sequence",
  ddListDescription: "DD list",
  parentId: "Parent ID",
  teamType: "Team type",
  teamName: "Team name",
  ageCutoffMonth: "Age cutoff month",
  ageCutoffDay: "Age cutoff day",
  status: "Status",
  createdAt: "Created at",
  createdBy: "Created by",
  updatedAt: "Updated at",
  updatedBy: "Updated by",
};

export const GOVERNING_BODY_SORT_FIELDS = {
  id: "ID",
  abbreviation: "Abbreviation",
  name: "Name",
  shortName: "ShortName",
  outputSequence: "OutputSequence",
  ddListDescription: "DdListDescription",
  parentId: "ParentId",
  teamType: "TeamType",
  teamName: "TeamName",
  ageCutoffMonth: "AgeCutoffMonth",
  ageCutoffDay: "AgeCutoffDay",
  status: "Status",
  createdAt: "CreatedAt",
  createdBy: "CreatedBy",
  updatedAt: "UpdatedAt",
  updatedBy: "UpdatedBy",
};

export const GOVERNING_BODY_SORT_OPTIONS = [
  { key: "name", label: "Name" },
  { key: "abbreviation", label: "Abbreviation" },
  { key: "outputSequence", label: "Output sequence" },
  { key: "updatedAt", label: "Updated at" },
  { key: "status", label: "Status" },
  { key: "id", label: "ID" },
];

export const formValueFields = {
  poolName: "",
  aquaticCenter: "",
  building: "",
  streetOne: "",
  streetTwo: "",
  streetThree: "",
  city: "",
  state: "",
  county: "",
  postalCode: "",
  country: "",
  email: "",
  backupEmail: "",
  googleMapsLink: "",
  mobilePhone: "",
  website: "",
  schoolInstitution: "",
};

export const formLoginFields = {
  username: "username",
  password: "password",
};

export const formTeamFields = {
  name: { short: "name", title: "Team name" },
  governingBodies: { short: "governingBodies", title: "Governing bodies" },
  coachEmail: { short: "coachEmail", title: "Coach email" },
  teamInfo: {
    short: "teamInfo",
    title: "Team info",
    data: [
      { id: 1, short: "divisionId", title: "Division ID" },
      { id: 2, short: "conference", title: "Conference ID" },
      { id: 3, short: "teamType", title: "Team type" },
      { id: 4, short: "abbreviation", title: "Abbreviation" },
      { id: 5, short: "diveMeetsId", title: "Dive meets ID" },
      { id: 6, short: "mascotName", title: "Plural mascot name" },
      { id: 7, short: "regionId", title: "Region ID" },
    ],
  },
  contactInformation: {
    short: "contactInformation",
    title: "Contact information",
    data: [
      { id: 8, short: "country", title: "Country" },
      { id: 6, short: "county", title: "County" },
      { id: 5, short: "state", title: "State" },
      { id: 4, short: "city", title: "City" },
      { id: 1, short: "streetOne", title: "Street" },
      { id: 2, short: "streetTwo", title: "Street 2" },
      { id: 3, short: "streetThree", title: "Street 3" },
      { id: 14, short: "gpsCoordinates", title: "GPS coordinates" },
      { id: 7, short: "postalCode", title: "Postal code" },
      { id: 12, short: "email", title: "Email" },
      { id: 13, short: "backupEmail", title: "Backup email" },
      { id: 9, short: "googleMapsLink", title: "Google map link" },
      { id: 11, short: "mobilePhone", title: "Mobile phone" },
      { id: 10, short: "workPhone", title: "Work phone" },
      { id: 15, short: "website", title: "Website" },
    ],
  },
  venues: { short: "venues", title: "Venues" },
  cloudAlias: { short: "cloudAlias", title: "Logo" },
};

export const dtoFormFields = {
  addressDto: {
    backupEmail: "",
    city: "",
    country: "",
    county: "",
    email: "",
    googleMapsLink: "",
    gpsCoordinates: "",
    id: "",
    mobilePhone: "",
    postalCode: "",
    state: "",
    streetOne: "",
    streetThree: "",
    streetTwo: "",
    website: "",
    workPhone: "",
    timezone: "",
  },
  aquaticCenter: "",
  building: "",
  city: "",
  country: "",
  firstLine: "",
  id: "",
  poolName: "",
  secondLine: "",
  schoolInstitution: "",
};

export const dtoFormTeamFields = {
  abbreviation: "",
  coachEmail: "",
  conference: "",
  contactInformation: {
    backupEmail: "",
    city: "",
    country: "",
    county: "",
    email: "",
    googleMapsLink: "",
    gpsCoordinates: "",
    id: "",
    mobilePhone: "",
    postalCode: "",
    state: "",
    streetOne: "",
    streetThree: "",
    streetTwo: "",
    website: "",
    workPhone: "",
  },
  diveMeetsId: "",
  divisionId: "",
  governingBodies: [],
  id: "",
  cloudAlias: "",
  teamType: "",
  mascotName: "",
  name: "",
  regionId: "",
  userCount: "",
  venues: [],
};
export const defaultParamsAdsTable = {
  page: 0,
  limit: 25,
  sort: "Id",
  isAscending: false, // DESC
};

export const defaultParamsViewTable = {
  page: 0,
  limit: 25,
  sort: "Id",
  isAscending: true,
};

export const defaultParamsGoverningBodiesTable = {
  page: 0,
  limit: 20,
  sort: "Name",
  isAscending: true,
  status: "ACTIVE",
  teamType: "ALL",
  query: "",
  locale: "en-US",
};

export const QUALIFYING_SCORE_SORT_TOKENS = [
  "Id",
  "AgeGroup",
  "Gender",
  "EventHeight",
  "DiveCount",
  "Points",
  "FromDate",
  "ToDate",
  "MinimumDd",
  "AttemptsRequired",
  "ConferenceId",
  "DivisionId",
  "RegionId",
  "CreatedAt",
  "UpdatedAt",
];

export const QUALIFYING_SCORE_SORT_TOKEN_LABELS = {
  Id: "ID",
  AgeGroup: "Age group",
  Gender: "Gender",
  EventHeight: "Height",
  DiveCount: "# dives",
  Points: "Points",
  FromDate: "From date",
  ToDate: "To date",
  MinimumDd: "Min DD",
  AttemptsRequired: "Attempts required",
  ConferenceId: "Conference",
  DivisionId: "Division",
  RegionId: "Region",
  CreatedAt: "Created at",
  UpdatedAt: "Updated at",
};

export const QUALIFYING_SCORE_DEFAULT_SORT = [
  "AgeGroup",
  "EventHeight",
  "Gender",
  "DiveCount",
];

export const defaultParamsQualifyingScoresTable = {
  page: 0,
  limit: 25,
  sort: QUALIFYING_SCORE_DEFAULT_SORT.join(","),
  isAscending: true,
};

export const QUALIFYING_SCORE_GENDER_OPTIONS = [
  { value: "Any", label: "Any" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const QUALIFYING_SCORE_HEIGHT_OPTIONS = [
  { value: 1, label: "1 meter" },
  { value: 3, label: "3 meter" },
  { value: 10, label: "Platform" },
];

export const QUALIFYING_SCORE_HEIGHT_LABELS = {
  1: "1 meter",
  3: "3 meter",
  10: "Platform",
};

export const QUALIFYING_SCORE_TEMPLATE_NAME = "QUALIFYING_SCORES";

// Division/Region filter match: EXACT for a picked suggestion, CONTAINS for typed text.
export const TEXT_MATCH = { EXACT: "EXACT", CONTAINS: "CONTAINS" };
export const formAdFields = {
  name: { short: "name", title: "Ad name" },
  teamId: { short: "teamId", title: "Team" },
  adType: { short: "adType", title: "Ad type" },
  clickUrl: { short: "clickUrl", title: "Click URL" },
  imageUrl: { short: "imageUrl", title: "Image URL (optional)" },
  imageObjectKey: {
    short: "imageObjectKey",
    title: "Image object key (e.g. ads/...)",
  },
  status: { short: "status", title: "Status" },
  governingBodies: { short: "governingBodies", title: "Governing bodies" },
  targetRoles: {
    short: "targetRoles",
    title: "Target roles",
  },

  ages: { short: "ages", title: "Ages" },
  levels: { short: "levels", title: "Levels" },
  shortDescription: { short: "shortDescription", title: "Short description" },
  ctaText: { short: "ctaText", title: "Call to action" },

  city: { short: "city", title: "City" },
  region: { short: "region", title: "Region/State" },
  country: { short: "country", title: "Country (ISO-2)" },

  maxUniqueImpressions: {
    short: "maxUniqueImpressions",
    title: "Max unique impressions",
  },
  maxUniqueClicks: { short: "maxUniqueClicks", title: "Max unique clicks" },
  priority: { short: "priority", title: "Priority" },

  startDate: { short: "startDate", title: "Start date (optional)" },
  endDate: { short: "endDate", title: "End date (optional)" },
};

export const MIN_SEARCH_KEY_LENGTH = 3;
export const TIME_OUT_REQUEST = 500;

export const ENVS = {
  LOCAL: {
    DOMAIN: "diving-dev.scoresandmore.live",
    GCP_BUCKET: "diving-dev-scoresandmore-live",
  },
  DEV: {
    DOMAIN: "diving-dev.scoresandmore.live",
    GCP_BUCKET: "diving-dev-scoresandmore-live",
  },
  QA: {
    DOMAIN: "diving-qa.scoresandmore.live",
    GCP_BUCKET: "diving-qa-scoresandmore-live",
  },
  PROD: {
    DOMAIN: "diving.scoresandmore.live",
    GCP_BUCKET: "diving-scoresandmore-live",
  },
};
export const GCP_URL = "https://storage.googleapis.com";

// Defensive: avoid crashing if REACT_APP_ENV is missing or not one of LOCAL/DEV/QA/PROD
const envKey = process.env.REACT_APP_ENV || "LOCAL";
const currentGcpBucket = ENVS[envKey]?.GCP_BUCKET || ENVS.LOCAL.GCP_BUCKET;

// Generic base (used by Ads object keys like "ads/...")
export const GCP_BUCKET_URL_BASE = `${GCP_URL}/${currentGcpBucket}/`;

// Existing team avatar location (keep consistent)
export const GCP_BUCKET_URL_AVATARS = `${GCP_URL}/${currentGcpBucket}/logo_images/`;

// Existing flags location (prod-only)
export const GCP_BUCKET_URL_FLAGS = `${GCP_URL}/${ENVS.PROD.GCP_BUCKET}/countryFlags/`;
